export default __webpack_public_path__ + "static/media/weclapp.e445030e.svg";